module.exports = __webpack_public_path__ + "img/resource-ys.379864dd.png";